<template>
  <div id="app">
    <div id="log"></div>
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      isRouterAlive: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  }
}
</script>

<style>
body {
  margin: 0;
  height: 100vh;
  min-height: 100%;
  padding: 0;
}
/**防止因BRCA发票页面缩小而引起的滚抖动 */
html {
  height: 100%;
  margin: 0;
  padding: 0;
}
*{
  list-style: none;

}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  height: 100%;
  overflow-y: auto;
}
.el-menu-item, .el-submenu__title {
  text-align: left;
}
.el-submenu .el-menu-item {
  height: 40px;
  line-height: 40px;
}
.clearfix {
  clear: both;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ".";
  clear: both;
  height: 0;
}
.el-pagination{
  text-align: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue